import { generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from '../axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { ECOM_LOGOUT } from '@/configs/ecom/apis';

export const logout = async (sessionId: string): Promise<any> => {
  try {
    return await axiosInstance.delete(`${generateBFFUrl(ECOM_LOGOUT)}/${sessionId}`);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
